<div class="row">
	<div class="col-9 col-xxl-9" #canvasParentContainer>
		<div class="canvas-image-container">
			<canvas #canvasImage
					width="900"
					height='470'
					[ngStyle]="{display: showLoading ? 'none' : 'initial'}"
					(mousedown)="onMouseDown($event)"
					(mousemove)="onMouseMove($event)"
					(mouseup)="onMouseUp($event)"
					(mouseout)="onMouseOut($event)"
			></canvas>

			<div class="render-loader" *ngIf="showLoading">
				<div class="card skeleton">
					<div class="card-body">
						<div class="card-img card-img-bottom loading">
							<div class="loader-icon">
								<i class="fas fa-images"></i>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="smart-tag-empty-rules-message" *ngIf="!photoIsAvailable">
				<img src="assets/img/placeholder/No-file-asset.png">
				<label class="no-results">No Image Available</label>
			</div>
		</div>

		<div class="confirm-blur-container" *ngIf="newBlur">
			<div class="buttons-container">
				<button pTooltip="Click to confirm the blur"
						tooltipZIndex="999999" pButton icon="far fa-check" (click)="confirmBlur()"></button>
				<button pTooltip="Click to cancel the blur"
						tooltipZIndex="999999" class="p-button-danger" pButton icon="far fa-times"
						(click)="cancelBlur()"></button>
			</div>
		</div>
	</div>
	<div class="col-3 col-xxl-3 data-container">

		<p-panel class="blur-panel-instructions" [collapsed]="true" header="Instructions" expandIcon="far fa-chevron-down" collapseIcon="far fa-chevron-up" [toggleable]="true">

			<p>Hide sensitive parts of your image by blurring selected areas</p>
			<ul>
				<li>First, add and apply all the blurs necessaries</li>
				<li>Then, rotate the image</li>
			</ul>
		</p-panel>
		<p-panel styleClass="card-draw-forms">
			<ng-template pTemplate="header">
				<div class="actions-container">
					<h2>Edit Blurs</h2>
					<button
						pButton
						class="p-button-outlined p-button-sm add-button"
						icon="fas fa-plus"
						pTooltip="Click to add a blur"
						tooltipZIndex="999999"
						[disabled]="loading || newBlur || saving"
						(click)="addNewBlur()">
					</button>
				</div>
			</ng-template>
			<div class="list-blur-container" [ngStyle]="{'height': canvasHeight, 'max-height': canvasHeight}">
				<p-dataView #dataView layout="list" *ngIf="listBlur.length > 0" [value]="listBlur">
					<ng-template pTemplate="listItem" let-rowIndexValue="rowIndex" let-blurShape>
						<div class="col-12 draw-form-container" [ngClass]="{'active' : blurShape.active}" (click)="onSelectBlur(rowIndexValue, blurShape)">
							<span>Blur {{ rowIndexValue + 1 }}</span>
							<div class="draw-form-action">
								<button
									pButton
									pRipple
									class="p-button-rounded p-button-text p-button-plain"
									pTooltip="Click to {{blurShape.visible ? 'show' : 'hide'}} the blur"
									[fitContent]="true"
									tooltipZIndex="999999"
									[icon]="blurShape.visible ? 'far fa-eye-slash' : 'far fa-eye' "
									(click)="showBlur(rowIndexValue)"></button>
								<button pButton pRipple class="p-button-rounded p-button-text p-button-plain"
										pTooltip="Click to delete a blur"
										tooltipZIndex="999999"
										(click)="removeBlur(rowIndexValue)"
										icon="far fa-trash"></button>
							</div>
						</div>
					</ng-template>

				</p-dataView>

				<div class="placeholder-blur-list" *ngIf="listBlur.length <= 0">
					<i class="far fa-list"></i>
					<p>No blur regions added yet.</p>
					<p><strong>Click the + button to add one.</strong></p>
				</div>
			</div>
		</p-panel>
	</div>
</div>

<div class="confirm-action-container">
	<button pButton class="btn-sm p-button-text p-button-secondary" label="Cancel" [disabled]="saving"
			(click)="onDismiss()"></button>
	<button pButton class="btn-sm btn-primary blur-save-button cv-btn-confirm" icon="far fa-save" label="Save"
			[loading]="loading" [disabled]="saving || newBlur || listChanges" (click)="onSaveBlur()"></button>
</div>
<p-confirmDialog></p-confirmDialog>
